export default (node) => {
  $('#hover-node-card .card-header').text(node.name)

  const fileName = node.data.defaultName || ''
  const delayReplyFor = node.data.delayReplyFor || ''
  const IsTypingOnDisplayChecked = node.data.IsTypingOnDisplayChecked || false

  let html = ''

  if (! fileName) {
    $('#hover-node-card .card-body').html('')
  } else {
    html += '<div class="hover-media-wrapper">'
    html += `<p><strong>Uploaded file:</strong> ${fileName}</p>`
    html += '</div>' 

    if (IsTypingOnDisplayChecked && delayReplyFor) {
      html += `<p><strong>Delay in reply:</strong> ${delayReplyFor} second(s)</p>`
    } 

    $('#hover-node-card .card-body').html(html)
  }  
}